import React from 'react';
import styles from './BazaarVoiceRating.module.scss';
import clsx from 'clsx';
import { useDisabledFeatureFlags } from 'lib/hooks/useDisabledFeatureFlags';

export interface BazaarVoiceRatingProps {
  ratingAndReviewContentId?: string;
  className?: string;
  showType?:
    | 'rating_summary'
    | 'reviews'
    | 'review_highlights'
    | 'inline-rating'
    | 'questions'
    | 'seller-ratings';
}

export function BazaarVoiceRating({
  ratingAndReviewContentId,
  className = '',
  showType = 'rating_summary',
}: BazaarVoiceRatingProps) {
  const disabledFeatures = useDisabledFeatureFlags();

  // Early return if BV is disabled from feature flags
  if (disabledFeatures?.BV) {
    return <></>;
  }

  if (!ratingAndReviewContentId) {
    console.warn('BazaarVoiceRating: ratingAndReviewContentId is required');
    return <></>;
  }

  return (
    <div
      className={clsx(styles[`bazaarVoiceRating--${showType}`], className, `printHide`)}
      data-bv-show={showType}
      data-bv-product-id={ratingAndReviewContentId}
    />
  );
}
